/**
 * dashboardHelpers.js — Phase 147 (Dashboard Cleanup). Pure helpers and
 * static lookup tables shared across Dashboard.jsx and its extracted tab
 * components (components/dashboard/*). No JSX, no side effects — safe to
 * import from anywhere.
 */

export const TABS = [
  { id: "overview",  label: "Overview" },
  { id: "people",    label: "People" },
  { id: "projects",  label: "Projects" },
  { id: "finance",   label: "Finance" },
  { id: "topposts",  label: "Top posts" },  // Phase 84.30 — cross-channel post feed
  { id: "inspiration", label: "Inspiration" },  // Phase 152 — curated studio inspiration feed
];

export const INR = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

// Phase 120 — "Fri, Sep 11th" style big date for the Overview hero.
export function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
}
export function bigDateLabel(d = new Date()) {
  const weekday = d.toLocaleDateString("en-US", { weekday: "short" });
  const month = d.toLocaleDateString("en-US", { month: "short" });
  return `${weekday}, ${month} ${ordinal(d.getDate())}`;
}

// Phase 152 — Inspiration Feed relative-time chip ("3h ago", "2d ago").
export function timeAgo(iso) {
  if (!iso) return "";
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

// --- small tone helpers (replace inline nested ternaries) ---
export const approvalTone = (kind) => ({
  review: "orange",
  leave: "blue",
  purchase: "orange",
  reimbursement: "green",
  weekly_report: "purple",
  new_employee: "blue",
  new_client: "blue",
  new_vendor: "blue",
  grievance: "red",
  recruitment: "yellow",
}[kind] || "slate");

// Phase 67 (iter51) — Kind labels for the "Needs you" filter chip strip, kept
// in sync with the Approvals page's KIND_META catalog so users see consistent
// terminology across both surfaces.
export const NEEDS_YOU_KIND_LABELS = {
  leave: "Leave",
  purchase: "Purchase",
  reimbursement: "Reimbursement",
  weekly_report: "Weekly",
  review: "Review",
  new_employee: "Onboarding",
  new_client: "Client",
  new_vendor: "Vendor",
  grievance: "Grievance",
  recruitment: "Recruitment",
};

export const attendanceTone = (checkedOut, checkedIn) => {
  if (checkedOut) return "green";
  if (checkedIn)  return "blue";
  return "slate";
};
export const attendanceLabel = (checkedOut, checkedIn) => {
  if (checkedOut) return "Complete";
  if (checkedIn)  return "Present";
  return "Not started";
};
export const leaveRemainingTone = (remaining) => {
  if (remaining <= 1) return "text-red-600";
  if (remaining <= 3) return "text-orange-600";
  return "text-slate-500";
};
export const goalTone = (status) => {
  if (status === "completed")  return "green";
  if (status === "in_progress")return "orange";
  return "slate";
};
